<div class="cosmos-searchbar">
  <form-field
    [formGroup]="_filterSearchTerm"
    class="cosmos-searchbar__field"
  >
    <div class="cosmos-searchbar__input">
      <div class="cosmos-searchbar__input__icon">
        <mat-icon>search</mat-icon>
      </div>
      <div>
        <input
          formControlName="filter"
          (keydown.enter)="submitSearch()"
          placeholder="{{ placeholderContent }}"
          class="cosmos-searchbar__input__textfield"
        />
      </div>
    </div>
  </form-field>
</div>
